<template>
		<div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24" v-if="listData && trueFalse">
					<div class="t-color4 t-color-bodyGrayA l-spacing36 font-rt-body3">{{ $t('1958')}}</div>
					<div class="mgt-8 mgb-16 font-m t-subtitle3">
						<vue-mathjax :formula="listData.question.contents" v-if="listData.question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ listData.question.contents }}
						</div>
					</div>
					<div v-if="listData.question.image">
						<img class="round mgb-8" :src="listData.question.image.resourceUri" alt="" v-if="listData.question.image">
				</div>
					<div class="b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 box-54"
					 v-for="(choice, index) in choices" :key="index"
						:class="{'bg-contentBlue': choice.correct === true,  'bg-quizGray': choice.correct === false && choice.selected === false, 'bg-contentRed': choice.correct === false && choice.selected === true}">
						<div class="d-flex align-items-center">
							<div class="q-count t-body1 l-spacing48 font-rn t-color-quizBlack" v-if="choice.correct === false && choice.selected === false" >{{index+1}}</div>
							<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === false && choice.selected === true">close</i>
							<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === true">radio_button_unchecked</i>
							<div class="t-body1  font-r flex-grow-1"
							:class="choice.correct === true ? 't-color-white': choice.correct === false && choice.selected === true ? 't-color-white' : 't-color-quizBlack'"
							>
								<vue-mathjax :formula="choice.contents" v-if="listData.question.useMathjax"></vue-mathjax>
								<div v-else>
									{{ choice.contents }}
								</div>
							</div>
							<div class="t-headline9 t-color-whiteMedium" v-if="choice.selectionRatio">
								{{parseInt(choice.selectionRatio)}}%
							</div>
						</div>
													<div class="mgt-8 mgb-8" v-if="choice.image && choice.image.resourceUri">
								<img class="round" :src="choice.image.resourceUri" alt="">
							</div>
					</div>
				</div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import examApi from "@/api/examApi.js";
import memberApi from "@/api/memberApi.js";

export default {
	props: ['listData', 'trueFalse'],
	data() {
		return {
			choices:[],
		}
	},
	mounted(){
		this.choices.push(this.trueFalse.answerTrue)
		this.choices.push(this.trueFalse.answerFalse)
	},
	components: {
	
	},
}
</script>

<style scoped>
.font-13 {
			font-size: 13px !important;
		}

		.l-spacing39 {
			letter-spacing: -0.39px;
		}
		.leftborder:before{
			content: '';
			position: absolute;
			width: 3px;
			height: 100%;
			border-radius: 4px;
			background: var(--ContentBlue);
			top:0;
			left: -3px;
		}
		html[dir="rtl"] .leftborder:before{
			right: -3px;
		}
		.problem {
			background-color: var(--QuizGray);
		}

		.problem .problem-sl-no {
			border: 1px solid var(--Textfeildactive);
			border-radius: 50%;
		}
		
		.problem.selected {
			background-color: var(--ContentBlue);
		}
		.problem.selected .problem-sl-no{
			color: var(--ContntentBlue) !important;
			border: 2px solid var(--DocumentWhite);
		}
		.problem.selected .answer{
			color: var(--DocumentWhite) !important;
		}
</style>
